var _module = require('../../module');
var moment = require('moment');

require('../../../filters');

_module.component('activityFeed',{
    bindings: {
        changelog: '=changeLog',
        showType: '=showType'
    },
    controllerAs: 'af',
    controller: [
        '$log',
        '$scope',

        function activityFeedCtrl($log, $scope) {
            var _this = this;

            this.showTypePredicate = function () {
                switch(_this.showType) {
                    case 'just_listed':
                        return {'favorite': false, 'type': 'new'};

                    case 'recently_sold':
                        return {'type': 'sold'};

                    case 'favorites':
                        return {'favorite': true};

                    case 'all':
                    default:
                        return {};

                }
            };

            this.displayAsLocalTime = function (dateString) {
                var t = dateString;
                if(dateString) {
                    t = new Date(dateString);
                    t = new Date( t.getTime() + ( t.getTimezoneOffset() * 60000 ) );
                }

                return t;
            };
        }
    ],
    template: require('./index.html')
});
